/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Incidents API
 * AV Services Incidents management API
 * OpenAPI spec version: 1.0
 */

export interface SpaceFilterOptionDto {
  title: string;
  value: string;
  /**
     * Building id for a floor, floor id for a room
     * @nullable
     */
  parentId?: string | null;
}
